import { render, staticRenderFns } from "./zdgz.vue?vue&type=template&id=bfd34482&scoped=true"
import script from "./zdgz.vue?vue&type=script&lang=js"
export * from "./zdgz.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfd34482",
  null
  
)

export default component.exports